import {
  type ScanSubmitTarget,
  type ScanSubmitTargetRegistry,
} from '../types/scanSubmitTarget.type';

export const createScanSubmitTargetRegistry = (): ScanSubmitTargetRegistry => {
  const targets = new Map<symbol, ScanSubmitTarget>();

  return {
    register: (target) => {
      const token = Symbol('scanSubmitTarget');
      targets.set(token, target);

      return {
        release: () => {
          targets.delete(token);
        },
        update: (nextTarget) => {
          if (targets.has(token)) targets.set(token, nextTarget);
        },
      };
    },
    reset: () => targets.clear(),
    snapshot: () => Array.from(targets.values()),
  };
};
